import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import IconServeceo from 'components/icons/iconServeceo';
import AffirmUpholsteryUpCharge from 'components/consumer/user-order-materials/components/AffirmUpholsteryUpCharge/AffirmUpholsteryUpCharge';
import CustomerDashboardPageTemplate from 'components/consumer/CustomerDashboardPageTemplate';
import UserProtectionPlans from './components/UserProtectionPlans/UserProtectionPlans';
export const getAffirmReturnParams = search => {
  const params = queryString.parse(search);
  const str = search ? search.split('?').pop() : '';
  if (str) {
    const [emailParam] = str.split('&').filter(p => p.includes('email='));
    if (emailParam) {
      const emailValue = emailParam.split('=').pop();
      if (emailValue) {
        params.email = decodeURIComponent(emailValue);
      }
    }
  }
  return params;
};
const UserProtectionPlansContainer = () => {
  const $ = _c(15);
  const {
    search
  } = useLocation();
  let t0;
  if ($[0] !== search) {
    t0 = getAffirmReturnParams(search);
    $[0] = search;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    oid,
    cid,
    email,
    product,
    plan_id,
    cart_id,
    plan_name,
    payment_token,
    checkout_token
  } = t0;
  if (checkout_token && payment_token) {
    let t1;
    if ($[2] !== cart_id || $[3] !== checkout_token || $[4] !== cid || $[5] !== email || $[6] !== oid || $[7] !== payment_token || $[8] !== plan_id || $[9] !== plan_name || $[10] !== product) {
      t1 = <AffirmUpholsteryUpCharge email={email} order_id={oid} customer_id={cid} cart_id={cart_id} plan_id={plan_id} plan_name={plan_name} product_name={product} payment_token={payment_token} checkout_token={checkout_token} />;
      $[2] = cart_id;
      $[3] = checkout_token;
      $[4] = cid;
      $[5] = email;
      $[6] = oid;
      $[7] = payment_token;
      $[8] = plan_id;
      $[9] = plan_name;
      $[10] = product;
      $[11] = t1;
    } else {
      t1 = $[11];
    }
    return t1;
  }
  let t1;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-3xl font-bold">Protection Plans</div>;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="w-[740px] flex flex-row justify-between max-[1023px]:w-[500px] max-[1023px]:m-auto max-[1023px]:flex-col max-[500px]:w-[90vw]">{t1}<div className="text-base font-bold max-[1023px]:mt-4"><span>{" In partnership with  "}</span><IconServeceo /></div></div>;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div data-xc="user-protection-plans"><CustomerDashboardPageTemplate title="Protection Plans" titleComponent={t2}><div className="w-[740px] max-[1023px]:w-[500px] max-[1023px]:m-auto max-[500px]:w-[90vw]"><UserProtectionPlans /></div></CustomerDashboardPageTemplate></div>;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default UserProtectionPlansContainer;